// extracted by mini-css-extract-plugin
export default {"root":"NotificationBadge_root__4+Gad h6"};